import Issue from './issueType';

const emptyIssue: Issue = {
  Assignee: '',
  Content: '',
  RepoUUID: '',
  Sprint: '',
  Status: '',
  StoryPoints: 0,
  TicketNumber: '',
  Title: '',
  Url: '',
};

export default emptyIssue;
